import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DxDataGridComponent } from "devextreme-angular";
import { Loadpopup } from "../../../../model/loadpopup";

@Component({
  selector: "app-loadpopup",
  templateUrl: "./loadpopup.component.html",
  styleUrls: ["./loadpopup.component.scss"],
})
export class LoadpopupComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: true })
  dataGrid: DxDataGridComponent;
  loadList: Loadpopup[] = [];
  loads: any[] = [];
  pickups: any[] = [];
  dropoffs: any[] = [];
  selectedLoadId: string = "";
  selectedRowKeys: any[] = [];
  selectedRows: number[] = [];
  jumpToPage = false;

  constructor(
    public dialogRef: MatDialogRef<LoadpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    // this.getLoadData();

    if (this.data) {
      if(this.data.loadId){
        this.jumpToPage = true;
      }
      this.loads = this.data.loadData;
      this.pickups = this.data.pickupData;
      this.dropoffs = this.data.dropoffData;
      console.log(this.loads.length);
      this.loads.forEach((load) => {
        const pickupData = this.pickups.filter((p) => p.load?._id ? p.load._id  == load._id : p.loadId == load._id);
        const dropffData = this.dropoffs.filter(
          (d) => d.loadId?._id == load?._id
        );
        let loadpopup = new Loadpopup();
        loadpopup._id = load._id;
        loadpopup.LoadNo = load.loadNumber;
        loadpopup.CustomerName = load.customer;
        loadpopup.LoadDate = load.date;
        loadpopup.FromPlace = pickupData[0]
          ? pickupData[0].address.fullAddress
          : "";
        loadpopup.ToPlace = dropffData[0]
          ? dropffData[0].dropAddress.fullAddress
          : "";
        this.loadList.push(loadpopup);
      });
    }
  }
  /*   async getLoadData() {
    await this._loadsService.getLoadData().subscribe(async (data) => {
      this.loads = await data.result;
    });

    await this._pickupService.getpickupData().subscribe(async (data) => {
      this.pickups = await data.result;
    });
    await this._dropoffService.getdroppoffData().subscribe(async (data) => {
      this.dropoffs = await data.result;
      this.setLoadInfo();
    });
  } */
  /*   setLoadInfo() {
    this.loads.forEach((load) => {
      const pickupData = this.pickups.filter((p) => p.loadId._id == load._id);
      const dropffData = this.dropoffs.filter((d) => d.loadId._id == load._id);
      let loadpopup = new Loadpopup();
      loadpopup._id = load._id;
      loadpopup.LoadNo = load.loadNumber;
      loadpopup.CustomerName = load.customer;
      loadpopup.LoadDate = load.date;
      loadpopup.FromPlace = pickupData[0].address.fullAddress;
      loadpopup.ToPlace = dropffData[0].dropAddress.fullAddress;
      this.loadList.push(loadpopup);
    });
  } */
  /*   radioBox_displayLoadExpr(load) {
    var d = new Date(load.LoadDate);

var datestring = d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear();
    return (
      load &&
      "Load no: " +
        load.LoadNo +
        " - Load Date: " +
        datestring +
        " - Customer Name: " +
        load.CustomerName +
        " - From place: " +
        load.FromPlace +
        " - To place: " +
        load.ToPlace
    );
  } */
  onRowPrepared(event) {
    if (this.jumpToPage) {
      this.jumpToPage = false;
      /* const totalCount = this.dataGrid.instance.totalCount();
      let pageSize = this.dataGrid.instance.pageSize();
      let pageCount = Math.ceil(totalCount / pageSize);
      if (pageCount && totalCount % pageSize) {
        this.dataGrid.instance.pageIndex(pageCount);
      } */
      const rowNumber = this.loadList.findIndex((d) => d._id === this.data.loadId);
      let pageSize = this.dataGrid.instance.pageSize();
      // let rowNumber = 11;
      let pageCount = Math.floor(rowNumber / pageSize);
      this.dataGrid.instance.pageIndex(pageCount);
      // this.dataGrid.instance.selectRows([0], true);
      const demo = [this.loadList[rowNumber]];
      this.selectedRowKeys = demo;
    }
  }
  onValueChanged(event: any) {
    console.log(event.value);
    this.selectedLoadId = event.value;
  }
  selectionChangedHandler() {
    this.selectedRowKeys = this.dataGrid.instance.getSelectedRowsData();
    this.dialogRef.close(this.selectedRowKeys[0]._id);
  }
  onRowClicked(event) {
    this.selectedRowKeys = this.dataGrid.instance.getSelectedRowsData();
    this.dialogRef.close(this.selectedRowKeys[0]._id);
  }
  hidePopup(){
    this.dialogRef.close(this.data.loadId);
  }
}
